import { useWordProcessor } from "./useWordProcessor.store";

export const useWordProcessorStore = (instanceId: string) => {
  return useWordProcessor(instanceId)();
};
